var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Delete Files", centered: "" },
      on: { hide: _vm.closeHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonPrimary",
                { attrs: { variant: "primary" }, on: { click: _vm.accept } },
                [_vm._v("\n      Yes\n    ")]
              ),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      No\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.isBriefLinkedFolder
        ? [
            _vm._v(
              "\n    This will unlink assets from the brief. Continue?\n  "
            ),
          ]
        : [
            _c("p", { staticClass: "delete-modal-text" }, [
              _vm._v("\n      Are you sure you want to delete file "),
              _c("strong", { staticClass: "delete-modal-file-name" }, [
                _vm._v(_vm._s(_vm.name)),
              ]),
              _vm._v("?\n      "),
              _c("br"),
              _vm._v("\n      This action cannot be undone.\n    "),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }